import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Keep braces: if an extension patches scrollTo to return a value, a
    // concise arrow would hand it to React as an effect cleanup and crash
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
